import React from "react";
import { RetryButton, ErrorContainer } from "../styles";
import { ErrorImage } from "./ErrorImage";
import { useAppTranslation } from "../../locales/translate";

interface Props {
  onRetry: () => void;
}

export const SettingsError = ({ onRetry }: Props) => {
  const { t } = useAppTranslation();

  return (
    <ErrorContainer>
      <ErrorImage />
      <div>
        <h3>{t("ERROR_MODAL_TITLE")}</h3>
        <p>{t("ERROR_MODAL_INFO_RETRY_TEXT")}</p>
      </div>
      <RetryButton primary onClick={onRetry}>
        {t("ERROR_MODAL_RETRY_BUTTON_TEXT")}
      </RetryButton>
    </ErrorContainer>
  );
};
